import { createContext, useContext } from "react";
import { SuccessModalContextType } from "./types";

export const SuccessModalContext = createContext<SuccessModalContextType>(
  {} as any,
);

export const useSuccessModal = () => useContext(SuccessModalContext);
